import { render, staticRenderFns } from "./InvestmentsFSSurvey.vue?vue&type=template&id=29eed5fd"
import script from "./InvestmentsFSSurvey.vue?vue&type=script&lang=ts"
export * from "./InvestmentsFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports